module.exports = __webpack_public_path__ + "img/dataservice_jcflfwgzz.239fa58c.png";